import isValidElementProp from './isValidElementProp';
import { createComponent as createFelaComponent } from 'react-fela';
import getReactDisplayName from 'react-display-name';
import { objectKeys } from './types';
var EMPTY_PASSTHROUGH_PROPS = []; // the order of these overloads is important to allow the compiler to
// correctly resolve to the right function signature

function createComponent(rule, base, passthroughProps) {
  var _base2, _passthroughProps;

  var _base = (_base2 = base) !== null && _base2 !== void 0 ? _base2 : 'div';

  var Component = createFelaComponent(rule, _base, (_passthroughProps = passthroughProps) !== null && _passthroughProps !== void 0 ? _passthroughProps : _base._isFelaComponent ? // fela merges the passthrough props of nested style components,
  // so if we're wrapping another style component we want to defer
  // determining passthrough props to a leaf-level component
  EMPTY_PASSTHROUGH_PROPS : typeof _base !== 'string' ? // A plain React component
  // (React component -> pass through all props)
  objectKeys : // a DOM element
  // (string -> dom element's acceptable props)
  function (props) {
    return objectKeys(props).filter(function (prop) {
      return isValidElementProp(_base, prop);
    });
  });
  Component.displayName = getReactDisplayName(_base);
  return Component;
}

export default createComponent;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/style-container/es/createComponent.js
// module id = 358
// module chunks = 0